import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, post } from 'utils/api';
import { logError } from 'utils/log';

import type {
  Action,
  Dispatch,
  GraphOverTimeProfileItem,
  GraphOverTimeStartDates,
  ThunkAction,
  TimeframeResult
} from 'types';

const INFLUENCER_GRAPHS_LOADING = 'sov/INFLUENCER_GRAPHS_LOADING';
const INFLUENCER_GRAPHS_LOADED = 'sov/INFLUENCER_GRAPHS_LOADED';
const INFLUENCER_GRAPHS_RESET = 'sov/INFLUENCER_GRAPHS_RESET';

const { INFLUENCER_GRAPHS } = API.END_POINTS;

const START_DATES = {
  instagram: '',
  tiktok: '',
  youtube: ''
};

const initialState = {
  results: [],
  startDates: START_DATES,
  isLoading: false
};


const setLoadingStatus = (type: string, status: boolean): Action => ({
  type,
  payload: {
    status
  }
});

const influencerGraphsLoaded = (
  results?: Array<GraphOverTimeProfileItem> | null,
  startDates?: GraphOverTimeStartDates | null
): Action => ({
  type: INFLUENCER_GRAPHS_LOADED,
  payload: {
    results: results || [],
    startDates: startDates || {}
  }
});

export const resetInfluencerGraphs = (): Action => ({
  type: INFLUENCER_GRAPHS_RESET
});

export const fetchInfluencerGraphs = (influencerProfileId: number, dateRange: TimeframeResult): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(setLoadingStatus(INFLUENCER_GRAPHS_LOADING, true));

  try {
    const url = INFLUENCER_GRAPHS.getInfluencerGraphs(influencerProfileId);
    const response = await post(url, { data: dateRange }, { suppressGlobalNotification: true });
    const graphOverTimeData = response.data ? response.data.graphOverTime : null;
    const graphDataStartDates = response.data ? response.data.graphDataStartDates : null;

    dispatch(influencerGraphsLoaded(graphOverTimeData, graphDataStartDates));
    dispatch(setLoadingStatus(INFLUENCER_GRAPHS_LOADING, false));
  } catch (e) {
    dispatch(setLoadingStatus(INFLUENCER_GRAPHS_LOADING, false));
    logError(e);
  }
};

export default createReducer<any, any>('influencerGraphs', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [INFLUENCER_GRAPHS_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [INFLUENCER_GRAPHS_LOADED]: (state, { results, startDates }) => ({
    ...state,
    results,
    startDates
  }),
  [INFLUENCER_GRAPHS_RESET]: (state) => ({
    ...state,
    results: [],
    startDates: START_DATES
  })
});
